import script from "./systemNoticeDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./systemNoticeDetail.vue?vue&type=script&lang=ts&setup=true"

import "./systemNoticeDetail.vue?vue&type=style&index=0&id=fb6013f4&lang=scss&scoped=true"

import exportComponent from "E:\\gitProject\\营城\\yingcheng\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb6013f4"]])

export default __exports__